import type { RuleActionType, RuleComparatorEnum, ScalarUnitEnum } from '~/store/services/RuleSetServiceV2/types';

export enum CriteriaSelection {
  DISABLED = 'disabled',
  INCLUDE_ONLY = 'include_only',
  OMIT_ONLY = 'omit_only',
  ADD = 'add',
  SPECIFIC = 'specific',
}

export const CRITERIA_SELECTION_TO_RULE_ACTION_TYPE: Record<CriteriaSelection, RuleActionType> = {
  [CriteriaSelection.INCLUDE_ONLY]: 'allow',
  [CriteriaSelection.OMIT_ONLY]: 'block',
  [CriteriaSelection.ADD]: 'add',
  // Not actually used
  [CriteriaSelection.SPECIFIC]: 'allow',
  [CriteriaSelection.DISABLED]: 'block',
};

export const RULE_ACTION_TYPE_TO_CRITERIA_SELECTION: Record<RuleActionType, CriteriaSelection> = {
  allow: CriteriaSelection.INCLUDE_ONLY,
  block: CriteriaSelection.OMIT_ONLY,
  add: CriteriaSelection.ADD,
};

export enum HazmatCriteriaOptions {
  NONE,
  LIMITED_QUANTITY,
  HAZMAT,
  FULL_HAZMAT,
}

export interface RulePageForm {
  name: string;
  description: string;
  tenantCriteria: CriteriaSelection;
  tenants: string[];
  originCriteria: CriteriaSelection;
  origins: string[];
  shipFromCriteria: CriteriaSelection;
  useShipFromCountry: boolean;
  originCountryCriteria: CriteriaSelection;
  originCountry: string[];
  useShipFromRegion: boolean;
  originRegionCriteria: CriteriaSelection;
  originRegion: string[];
  useShipFromPostalCodes: boolean;
  originPostalCriteria: CriteriaSelection;
  originPostalCodes: string[];
  destinationCriteria: CriteriaSelection;
  useCountry: boolean;
  countryCriteria: CriteriaSelection;
  country: string[];
  useRegion: boolean;
  regionCriteria: CriteriaSelection;
  region: string[];
  usePostalCodes: boolean;
  postalCodeCriteria: CriteriaSelection;
  postalCodes: string[];
  packageCriteria: CriteriaSelection;
  packageWeightComparator: RuleComparatorEnum | '';
  packageWeightUnitValue: ScalarUnitEnum | '';
  packageValue: string;
  poBoxCriteria: CriteriaSelection;
  includeHcAndRr: boolean;
  exactDateDeliveryCriteria: CriteriaSelection;
  shipmentTagCriteria: CriteriaSelection;
  shipmentTags: string[];
  carrierSelectionCriteria: CriteriaSelection;
  eligibleCarrierServiceMethods: string[];
  shipOptionCriteria: CriteriaSelection;
  shipOptions: string[];
  hazardousCriteria: CriteriaSelection;
  hazardousCriteriaOptions: HazmatCriteriaOptions;
}
